import { IDataset } from 'app/shared/model/dataset.model';

export interface IReferenceMaterial {
  id?: number;
  name?: string;
  datasets?: IDataset[] | null;
}

export const defaultValue: Readonly<IReferenceMaterial> = {};
